/**
 * All user-facing copy in one place so we can localize later.
 * Grouped by page/concern. Keep keys stable once used.
 */
export const strings = {
  app: {
    name: 'OpenBookMap',
    tagline: 'A global atlas · of used bookstores · and the books inside them',
  },
  nav: {
    about: 'About',
    map: 'Map',
    search: 'Search',
    contribute: 'Contribute',
    me: 'Me',
  },
  map: {
    zoomIn: 'zoom in to load',
    searchPlaceholder: 'Search a city…',
    searchGo: 'Go',
    loading: 'Loading bookstores…',
    fetchFailed: 'fetch failed — try again',
    searchFailed: 'Search failed — try again.',
    cityNotFound: (q) => `Could not find "${q}"`,
    shopCount: (n, added) => `${n} shops${added ? ` (+${added})` : ''}`,
    noPhotos: 'No photos yet. Be the first to contribute.',
    noBooks: 'No books indexed yet.',
    contributeCta: 'Contribute photos →',
    unnamed: 'Unnamed bookstore',
    unknownAddress: 'Address unknown',
  },
  contribute: {
    signInTitle: 'Sign in to contribute',
    signInLede:
      'Create an account or sign in to upload shelf photos. Email + password — no magic link limits.',
    emailLabel: 'Email',
    passwordLabel: 'Password (min 8 characters)',
    signIn: 'Sign in',
    signUp: 'Create account',
    signOut: 'Sign out',
    switchToSignUp: 'No account? Create one →',
    switchToSignIn: '← Back to sign in',
    signedInAs: (email) => `Signed in as ${email}`,
    needShop: 'Pick a shop on the map first, then click "Contribute photos" there.',
    dropzone: 'Drop shelf photos here, or click to choose',
    ocrPending: 'OCR queued…',
    ocrRunning: 'Reading spines…',
    ocrDone: 'OCR complete — confirm titles below',
    ocrFailed: 'OCR failed — you can type titles manually',
    uploading: 'Uploading…',
    uploadSuccess: 'Saved. Thank you — your contribution is live.',
    uploadFailed: 'Upload failed — some photos may not have saved.',
    licenseNote:
      'By contributing, you release photos under CC-BY-SA 4.0 and title metadata under ODbL-compatible terms.',
    addTitle: '+ Add title',
    removeTitle: 'Remove this title',
    confirmed: 'Confirmed',
  },
  shop: {
    notFound: 'Shop not found.',
    loading: 'Loading shop…',
    photos: 'Shelf photos',
    books: 'Books on the shelves',
    contributions: 'Recent contributions',
    openInOsm: 'View in OpenStreetMap →',
  },
  search: {
    placeholder: 'Search shops or book titles…',
    go: 'Search',
    empty: (q) => `No results for "${q}".`,
    shopsHeading: 'Shops',
    booksHeading: 'Books',
    noQuery: 'Type a query above to search across every shop and every book on the map.',
  },
  me: {
    signedOut: 'You are not signed in.',
    heading: 'My contributions',
    noContributions: 'You haven’t contributed anything yet. Find a shop on the map to start.',
    photosHeading: 'Photos',
    booksHeading: 'Books',
    deleteConfirm: 'Delete this? This cannot be undone.',
    deleted: 'Deleted.',
    deleteFailed: 'Delete failed.',
    usernameLabel: 'Username (letters, numbers, dashes — used in your profile URL)',
    bioLabel: 'Bio (optional)',
    save: 'Save',
    savedSuccess: 'Profile updated.',
    saveFailed: 'Could not save profile.',
    usernameTaken: 'That username is taken.',
  },
  errors: {
    generic: 'Something went wrong. Please try again.',
    network: 'Network error — check your connection.',
    notSignedIn: 'You must sign in to do that.',
  },
};
